import { Controller } from "@hotwired/stimulus"
import { sendJSON } from "../api.js"

// Tabela leadów — część KLIENCKA: zaznaczanie wierszy + masowe dodanie do koszyka.
//
// Sortowanie i paginacja są SERVER-SIDE (parametry URL; wiersze renderuje kontroler
// `catalog` z DRF) — ten kontroler ich nie dotyka.
//
// "Dodaj zaznaczone" POST-uje {listing_ids} na /api/cart/add-bulk/; API zwraca
// {added: [...]} — odbijamy stan TYLKO dla realnie dodanych (część mogła zostać
// w międzyczasie zarezerwowana przez kogoś innego).
export default class extends Controller {
  static targets = ["row", "bulkbar", "selCount"]
  static values  = { addUrl: String }

  connect() { this.#refresh() }

  toggleRow() { this.#refresh() }

  clear() {
    this.rowTargets.forEach(cb => { cb.checked = false; this.#markRow(cb, false) })
    this.#refresh()
  }

  async addSelected() {
    // Pomiń pozycje już będące w koszyku — re-POST tylko odświeżałby im TTL rezerwacji.
    const ids = this.#selectedIds().filter(id => {
      const btn = document.querySelector(`.ls-add-btn[data-cart-id-param="${id}"]`)
      return !btn?.classList.contains("is-in-cart")
    })
    if (!ids.length) {
      this.clear()
      return
    }
    const res = await sendJSON("POST", this.addUrlValue, { listing_ids: ids })
    if (!res.ok) return
    const added = res.data?.added ?? []

    added.forEach(id => {
      const btn = document.querySelector(`.ls-add-btn[data-cart-id-param="${id}"]`)
      if (btn && !btn.classList.contains("is-in-cart")) {
        btn.classList.add("is-in-cart")
        btn.querySelector(".ls-mono").textContent = "✓"
        btn.querySelector("[data-cart-label]").textContent = "W koszyku"
        const row = btn.closest(".ls-lead-row")
        if (row) row.classList.add("is-selected")
      }
    })
    // Odśwież drawer koszyka (sumy + pozycje) przez kontroler `cart` na tej stronie.
    const cartEl = document.querySelector('[data-controller~="cart"]')
    if (cartEl) {
      const ctrl = this.application.getControllerForElementAndIdentifier(cartEl, "cart")
      if (ctrl) await ctrl.load()
    }
    this.clear()
  }

  // --- prywatne ---
  #selectedIds() { return this.rowTargets.filter(cb => cb.checked).map(cb => Number(cb.value)) }

  #refresh() {
    const n = this.#selectedIds().length
    this.rowTargets.forEach(cb => this.#markRow(cb, cb.checked))
    if (this.hasBulkbarTarget)  this.bulkbarTarget.hidden = n === 0
    if (this.hasSelCountTarget) this.selCountTarget.textContent = n
  }

  #markRow(cb, on) {
    const row = cb.closest(".ls-lead-row")
    if (!row) return
    // Podświetlenie zostaje, gdy wiersz jest w koszyku (is-selected pełni też rolę "in cart").
    const inCart = row.querySelector(".ls-add-btn")?.classList.contains("is-in-cart") ?? false
    row.classList.toggle("is-selected", on || inCart)
  }
}
